import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import ErrorMessage from './components/ErrorMessage';
import LoadingSpinner from './components/LoadingSpinner';
import LoginButton from './components/LoginButton';
import MainContent from './components/MainContent';
import Sidebar from './components/Sidebar';
import { UserProvider } from './contexts/UserContext';

// Placeholder imports for new components
import ClientDetailPage from './components/ClientDetailPage';
import ClientList from './components/ClientList';
import DefaultClientRedirect from './components/DefaultClientRedirect';

const App: React.FC = () => {
  const { isLoading: authLoading, isAuthenticated, error: authError } = useAuth0();

  // Show loading spinner while Auth0 is initializing
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <LoadingSpinner />
      </div>
    );
  }

  // Show auth error if there's an authentication error
  if (authError) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <ErrorMessage 
          message={`Authentication error: ${authError.message}`} 
          onRetry={() => window.location.reload()} 
        />
      </div>
    );
  }

  // Show login screen if not authenticated
  if (!isAuthenticated) {
    return <LoginButton />;
  }

  // Only render the authenticated dashboard when user is authenticated
  return (
    <UserProvider>
      <Router>
        <div className="flex min-h-screen bg-white">
          <Sidebar />
          <MainContent>
            <Routes>
              <Route path="/clients" element={<ClientList />} />
              <Route path="/clients/:clientId" element={<ClientDetailPage />} />
              <Route path="/" element={<DefaultClientRedirect />} />
              <Route path="*" element={<DefaultClientRedirect />} />
            </Routes>
          </MainContent>
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;
